export default "__VITE_ASSET__B3D1LanQ__"